import { render, staticRenderFns } from "./GiftModal.vue?vue&type=template&id=0727657c&scoped=true&"
import script from "./GiftModal.vue?vue&type=script&lang=js&"
export * from "./GiftModal.vue?vue&type=script&lang=js&"
import style0 from "./GiftModal.vue?vue&type=style&index=0&id=0727657c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0727657c",
  null
  
)

export default component.exports